/**
 * Function to generate dynamic TTS description based on settings
 * @param {boolean|undefined} ttsValue - The TTS setting value (true, false, or undefined for student level)
 * @param {boolean|undefined} ttsForPassagesValue - The TTS for passages setting value
 * @returns {string} - The description text for the TTS setting
 */
export const getTtsDescription = (ttsValue, ttsForPassagesValue) => {
  const isEnabled = ttsValue === true
  const isStudentLevel = ttsValue === undefined
  const isDisabled = ttsValue === false
  const isPassageEnabled = ttsForPassagesValue === true

  if (isEnabled && isPassageEnabled) {
    return 'TTS is enabled for all students on all items and passages. Passage text and questions are read aloud.'
  }
  if (isEnabled && !isPassageEnabled) {
    return 'TTS is enabled for all students on all items. On passages, only the questions are read aloud (not the passage text).'
  }
  if (isStudentLevel && isPassageEnabled) {
    return 'TTS is enabled on all items and passages for students with the TTS accommodation ON. Passage text and questions are read aloud.'
  }
  if (isStudentLevel && !isPassageEnabled) {
    return 'TTS is enabled on all items for students with the TTS accommodation ON. On passages, only the questions are read aloud (not the passage text).'
  }
  if (isDisabled) {
    return 'TTS is disabled for this test.'
  }

  return 'Text-to-Speech is always available for questions when set to Enable/Student level, regardless of the passage setting. To prevent TTS from reading passages, set TTS for Passage Content to Disable.'
}

export const getTTSTooltipDescription = (ttsValue) => {
  const isEnabled = ttsValue === true
  const isStudentLevel = ttsValue === undefined
  const isDisabled = ttsValue === false

  if (isStudentLevel) {
    return 'Applies to students with accommodations enabled in Manage Class.'
  }
  if (isEnabled) {
    return 'Applies accommodations to all students.'
  }
  if (isDisabled) {
    return 'Turns off accommodations for all students.'
  }
  return ''
}

/**
 * Function to generate tooltip text for Speech-to-Text radio button based on button ID
 * @param {string} buttonId - The ID of the radio button (student-level, enable, disable)
 * @returns {string} - The tooltip text for the specific radio button
 */
export const getSpeechToTextTooltipByButtonId = (buttonId) => {
  if (buttonId.endsWith('-student-level')) {
    return 'Applies to students with accommodations enabled in Manage Class.'
  } else if (buttonId.endsWith('-enable')) {
    return 'Enables for all students.'
  } else if (buttonId.endsWith('-disable')) {
    return 'Disables for all students.'
  }

  return ''
}
